/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/IntegrationFinancialUploadBatchFileReport', 'model/FileTransferHelperEntity', 'model/IntegrationFinancialUploadBatch', 'model/FinancialBatchPreviewReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/IntegrationFinancialUploadBatchFileReport'), require('../model/FileTransferHelperEntity'), require('../model/IntegrationFinancialUploadBatch'), require('../model/FinancialBatchPreviewReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.IntegrationFinancialUploadBatchApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.IntegrationFinancialUploadBatchFileReport, root.ForStractionServiceApi.FileTransferHelperEntity, root.ForStractionServiceApi.IntegrationFinancialUploadBatch, root.ForStractionServiceApi.FinancialBatchPreviewReport);
  }
}(this, function(ApiClient, IntegrationFinancialUploadBatchFileReport, FileTransferHelperEntity, IntegrationFinancialUploadBatch, FinancialBatchPreviewReport) {
  'use strict';

  /**
   * IntegrationFinancialUploadBatch service.
   * @module api/IntegrationFinancialUploadBatchApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new IntegrationFinancialUploadBatchApi. 
   * @alias module:api/IntegrationFinancialUploadBatchApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the integrationFinancialUploadBatchCheckBatchStatusGet operation.
     * @callback module:api/IntegrationFinancialUploadBatchApi~integrationFinancialUploadBatchCheckBatchStatusGetCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * checkBatchStatus
     * @param {String} _4SAPIAppID 
     * @param {Integer} batchID 
     * @param {module:api/IntegrationFinancialUploadBatchApi~integrationFinancialUploadBatchCheckBatchStatusGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.integrationFinancialUploadBatchCheckBatchStatusGet = function(_4SAPIAppID, batchID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationFinancialUploadBatchCheckBatchStatusGet";
      }

      // verify the required parameter 'batchID' is set
      if (batchID == undefined || batchID == null) {
        throw "Missing the required parameter 'batchID' when calling integrationFinancialUploadBatchCheckBatchStatusGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'batchID': batchID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/IntegrationFinancialUploadBatch/checkBatchStatus', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the integrationFinancialUploadBatchCreateExcelBatchPut operation.
     * @callback module:api/IntegrationFinancialUploadBatchApi~integrationFinancialUploadBatchCreateExcelBatchPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * createExcelBatch
     * @param {String} _4SAPIAppID 
     * @param {module:model/IntegrationFinancialUploadBatchFileReport} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.batchLegalEntityID 
     * @param {module:api/IntegrationFinancialUploadBatchApi~integrationFinancialUploadBatchCreateExcelBatchPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.integrationFinancialUploadBatchCreateExcelBatchPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationFinancialUploadBatchCreateExcelBatchPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling integrationFinancialUploadBatchCreateExcelBatchPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'batchLegalEntityID': opts['batchLegalEntityID']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/IntegrationFinancialUploadBatch/createExcelBatch', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the integrationFinancialUploadBatchImportAndProcessFilesPut operation.
     * @callback module:api/IntegrationFinancialUploadBatchApi~integrationFinancialUploadBatchImportAndProcessFilesPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/IntegrationFinancialUploadBatch} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * importAndProcessFiles
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/FileTransferHelperEntity>} body 
     * @param {Integer} sourceID 
     * @param {Date} startPeriod 
     * @param {Date} endPeriod 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.legalEntityID 
     * @param {Boolean} opts.startImmediately  (default to false)
     * @param {module:api/IntegrationFinancialUploadBatchApi~integrationFinancialUploadBatchImportAndProcessFilesPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/IntegrationFinancialUploadBatch}
     */
    this.integrationFinancialUploadBatchImportAndProcessFilesPut = function(_4SAPIAppID, body, sourceID, startPeriod, endPeriod, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationFinancialUploadBatchImportAndProcessFilesPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling integrationFinancialUploadBatchImportAndProcessFilesPut";
      }

      // verify the required parameter 'sourceID' is set
      if (sourceID == undefined || sourceID == null) {
        throw "Missing the required parameter 'sourceID' when calling integrationFinancialUploadBatchImportAndProcessFilesPut";
      }

      // verify the required parameter 'startPeriod' is set
      if (startPeriod == undefined || startPeriod == null) {
        throw "Missing the required parameter 'startPeriod' when calling integrationFinancialUploadBatchImportAndProcessFilesPut";
      }

      // verify the required parameter 'endPeriod' is set
      if (endPeriod == undefined || endPeriod == null) {
        throw "Missing the required parameter 'endPeriod' when calling integrationFinancialUploadBatchImportAndProcessFilesPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'sourceID': sourceID,
        'startPeriod': startPeriod,
        'endPeriod': endPeriod,
        'legalEntityID': opts['legalEntityID'],
        'startImmediately': opts['startImmediately']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = IntegrationFinancialUploadBatch;

      return this.apiClient.callApi(
        '/IntegrationFinancialUploadBatch/importAndProcessFiles', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the integrationFinancialUploadBatchImportExcelBatchGet operation.
     * @callback module:api/IntegrationFinancialUploadBatchApi~integrationFinancialUploadBatchImportExcelBatchGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * importExcelBatch
     * @param {String} _4SAPIAppID 
     * @param {Integer} batchID 
     * @param {Boolean} startBackgroundWorker 
     * @param {module:api/IntegrationFinancialUploadBatchApi~integrationFinancialUploadBatchImportExcelBatchGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.integrationFinancialUploadBatchImportExcelBatchGet = function(_4SAPIAppID, batchID, startBackgroundWorker, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationFinancialUploadBatchImportExcelBatchGet";
      }

      // verify the required parameter 'batchID' is set
      if (batchID == undefined || batchID == null) {
        throw "Missing the required parameter 'batchID' when calling integrationFinancialUploadBatchImportExcelBatchGet";
      }

      // verify the required parameter 'startBackgroundWorker' is set
      if (startBackgroundWorker == undefined || startBackgroundWorker == null) {
        throw "Missing the required parameter 'startBackgroundWorker' when calling integrationFinancialUploadBatchImportExcelBatchGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'batchID': batchID,
        'startBackgroundWorker': startBackgroundWorker
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/IntegrationFinancialUploadBatch/importExcelBatch', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the integrationFinancialUploadBatchLoadLatestFinancialSystemBatchesGet operation.
     * @callback module:api/IntegrationFinancialUploadBatchApi~integrationFinancialUploadBatchLoadLatestFinancialSystemBatchesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/IntegrationFinancialUploadBatch>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadLatestFinancialSystemBatches
     * @param {String} _4SAPIAppID 
     * @param {module:api/IntegrationFinancialUploadBatchApi~integrationFinancialUploadBatchLoadLatestFinancialSystemBatchesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/IntegrationFinancialUploadBatch>}
     */
    this.integrationFinancialUploadBatchLoadLatestFinancialSystemBatchesGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationFinancialUploadBatchLoadLatestFinancialSystemBatchesGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [IntegrationFinancialUploadBatch];

      return this.apiClient.callApi(
        '/IntegrationFinancialUploadBatch/loadLatestFinancialSystemBatches', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the integrationFinancialUploadBatchPreviewExcelBatchGet operation.
     * @callback module:api/IntegrationFinancialUploadBatchApi~integrationFinancialUploadBatchPreviewExcelBatchGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FinancialBatchPreviewReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * previewExcelBatch
     * @param {String} _4SAPIAppID 
     * @param {Integer} batchID 
     * @param {module:api/IntegrationFinancialUploadBatchApi~integrationFinancialUploadBatchPreviewExcelBatchGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FinancialBatchPreviewReport}
     */
    this.integrationFinancialUploadBatchPreviewExcelBatchGet = function(_4SAPIAppID, batchID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationFinancialUploadBatchPreviewExcelBatchGet";
      }

      // verify the required parameter 'batchID' is set
      if (batchID == undefined || batchID == null) {
        throw "Missing the required parameter 'batchID' when calling integrationFinancialUploadBatchPreviewExcelBatchGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'batchID': batchID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = FinancialBatchPreviewReport;

      return this.apiClient.callApi(
        '/IntegrationFinancialUploadBatch/previewExcelBatch', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the integrationFinancialUploadBatchUnlinkBatchesFromLegalEntityGet operation.
     * @callback module:api/IntegrationFinancialUploadBatchApi~integrationFinancialUploadBatchUnlinkBatchesFromLegalEntityGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * unlinkBatchesFromLegalEntity
     * @param {String} _4SAPIAppID 
     * @param {Integer} companyLegalEntityID 
     * @param {module:api/IntegrationFinancialUploadBatchApi~integrationFinancialUploadBatchUnlinkBatchesFromLegalEntityGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.integrationFinancialUploadBatchUnlinkBatchesFromLegalEntityGet = function(_4SAPIAppID, companyLegalEntityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationFinancialUploadBatchUnlinkBatchesFromLegalEntityGet";
      }

      // verify the required parameter 'companyLegalEntityID' is set
      if (companyLegalEntityID == undefined || companyLegalEntityID == null) {
        throw "Missing the required parameter 'companyLegalEntityID' when calling integrationFinancialUploadBatchUnlinkBatchesFromLegalEntityGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'companyLegalEntityID': companyLegalEntityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/IntegrationFinancialUploadBatch/unlinkBatchesFromLegalEntity', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
